module.exports = __webpack_public_path__ + "img/goyoga-manager-creer-site-web-reservation.630dc79.jpeg";